import { Observable } from "rxjs";

export function extractEdges() {
  return function<T>(source: Observable<any>): Observable<T> {
    return new Observable(subscriber => {
      source.subscribe({
        next(value) {
          subscriber.next(value.edges);
        },
        error(error) {
          subscriber.error(error);
        },
        complete() {
          subscriber.complete();
        }
      })
    });
  }
}
